import { render, staticRenderFns } from "./DataList.vue?vue&type=template&id=08953db7"
import script from "./DataList.vue?vue&type=script&lang=js"
export * from "./DataList.vue?vue&type=script&lang=js"
import style0 from "./DataList.vue?vue&type=style&index=0&id=08953db7&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports